export const MOVING_WIDGET = 'moving-widget';
export const START_DRAGGING = 'start-dragging';
export const STOP_DRAGGING = 'stop-dragging';